import React from 'react';
import {useEffect} from 'react';
import Calendar from '../components/Calendar/Calendar';
import '../components/Calendar/Calendar.css';


function Home() {
    
    useEffect(() => {
    document.title = "Blues and Swing resouces in Berlin - Zane Payer";
    }, []);
    return (
    <div>
    <div className='calendar' >
        <Calendar />
    </div>
    </div>
    
    )
  }

  export default Home